import React from 'react';
import CardWithSite from '../../../components/Campanhas/BoxWithSite';
import Container from '../../../components/Campanhas/SitesContainer';
import SitesEnum from '../../../services/enums/sites/navItemsEnum';

const WithSites = () => (
	<Container
		siteHeader="Sites"
		links={SitesEnum}
	>
		<CardWithSite />
	</Container>
);

export default WithSites;
